export default "__VITE_ASSET__G5ScJRZf__"